angular.module('shared').factory('TemplateSanitizeService', ["$filter", function($filter) {
  return {
    sanitize: function(template) {
      var t;
      t = template.plain ? template.plain() : template;
      switch (t.channel) {
        case 'email':
          t.subject = $filter('sanitizeEditorField')(t.subject, true, {
            target: 'subject'
          });
          t.content = $filter('domPurify')(t.content);
          break;
        case 'push_notification':
          t.subject = $filter('sanitizeEditorField')(t.subject, true, {
            target: 'subject'
          });
          t.content = $filter('sanitizeEditorField')(t.content, true);
          t.reply_address = void 0;
          break;
        default:
          t.content = $filter('sanitizeEditorField')(t.content, true);
          t.reply_address = void 0;
      }
      return t;
    }
  };
}]);
